// ABOUTME: Hacia dónde mira la cara en una imagen (yaw), con el Face Landmarker de MediaPipe en
// ABOUTME: modo imagen. Sirve para comprobar que las vistas de lado salen hacia lados distintos.
import { FaceLandmarker, FilesetResolver } from "@mediapipe/tasks-vision";
import { poseAngles } from "../calibration/measure";
import { toColumnMajor } from "../ar/matrix";

let landmarkerPromise: Promise<FaceLandmarker> | null = null;

function landmarker(): Promise<FaceLandmarker> {
  if (!landmarkerPromise) {
    const base = import.meta.env.BASE_URL.replace(/\/$/, "");
    landmarkerPromise = FilesetResolver.forVisionTasks(`${base}/wasm`).then((fileset) =>
      FaceLandmarker.createFromOptions(fileset, {
        baseOptions: { modelAssetPath: `${base}/models/face_landmarker.task`, delegate: "GPU" },
        runningMode: "IMAGE",
        numFaces: 1,
        outputFacialTransformationMatrixes: true,
      }),
    );
  }
  return landmarkerPromise;
}

/** Yaw en grados (positivo = la cara gira hacia la derecha de la imagen), o null si no hay cara. */
export async function faceYaw(blob: Blob): Promise<number | null> {
  const bitmap = await createImageBitmap(blob);
  try {
    const result = (await landmarker()).detect(bitmap);
    const m = result.facialTransformationMatrixes?.[0];
    return m ? poseAngles(toColumnMajor(m.data)).yawDeg : null;
  } finally {
    bitmap.close();
  }
}

/** Espeja horizontalmente una imagen. */
export async function mirrorBlob(blob: Blob): Promise<Blob> {
  const bitmap = await createImageBitmap(blob);
  const canvas = document.createElement("canvas");
  canvas.width = bitmap.width;
  canvas.height = bitmap.height;
  const ctx = canvas.getContext("2d")!;
  ctx.translate(canvas.width, 0);
  ctx.scale(-1, 1);
  ctx.drawImage(bitmap, 0, 0);
  bitmap.close();
  return new Promise((resolve, reject) => canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("toBlob falló"))), "image/jpeg", 0.92));
}
